import {RouteName} from '@toolify/client/src/setup/router/enum/RouteName'

const guestAuthRouteNames = new Set<string>([
  RouteName.Login,
  RouteName.Register,
  RouteName.ForgotPassword,
  RouteName.ResetPassword,
  RouteName.VerifyMailAddress,
  RouteName.VerifyMailChange,
  RouteName.VerifyPasswordChange,
  RouteName.Invitation,
  RouteName.TwoFactorLogin,
  RouteName.OAuthIdentityCallback,
])

export function isGuestAuthRouteName(name: unknown): boolean {
  return typeof name === 'string' && guestAuthRouteNames.has(name)
}
